var map = {
	"./add-existing-registry-banner.gif": 1406,
	"./addexistingregistry_379x180_v2.jpg": 596,
	"./addexistingregistry_548x260.jpg": 1407,
	"./computer.png": 459,
	"./computer@2x.png": 1408,
	"./event.png": 188,
	"./event@2x.png": 1409,
	"./faq.png": 1410,
	"./faq@2x.png": 1411,
	"./home.png": 1412,
	"./home@2x.png": 1413,
	"./photo.png": 1414,
	"./photo@2x.png": 1415,
	"./poi.png": 1416,
	"./poi@2x.png": 1417,
	"./registry-video.jpg": 1418,
	"./registry-video@2x.jpg": 1419,
	"./registry.png": 1420,
	"./registry@2x.png": 1421,
	"./registryconversion_zolaintegration.jpg": 1422,
	"./registryconversion_zolaintegration@2x.jpg": 1423,
	"./rsvp.png": 1424,
	"./rsvp@2x.png": 1425,
	"./travel.png": 1426,
	"./travel@2x.png": 1427,
	"./wedding_party.png": 1428,
	"./wedding_party@2x.png": 1429
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1405;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1405
// module chunks = 49